<template>
  <div class="record-general-container">
    <header class="record-header">
      <div class="header-left-logo">
        <router-link
          to="/map"
        >
          <img src="../assets/logo.svg" alt="" srcset="">
        </router-link>
      </div>
      <div class="right-info">
        <router-link to="/about">
          Sobre el proyecto
        </router-link>
      </div>
    </header>
    <div class="record-content">

      <!-- back to map route -->
      <router-link
        to="/map"
        class="back"
      >
        &#60;volver
      </router-link>
      
      <!-- Record's title -->
      <div class="record-title">
        <h1>
          {{ record.title }}
        </h1>
      </div>

      <!-- Line break -->
      <SquaresRoad class="first-line-break" :squareNum="18" :squareHeight="3" :roadWidth="50"/>

      <!-- Record's information rectangle -->
      <div class="record-info-rect">
        <!-- Author -->
        <div
          class="info-rect-piece first"
          v-if="record.author.length"
        >        
          <div class="rect-piece-title">
            Autor
          </div>
          <div class="rect-piece-content">
            <h2>
              {{ record.author.join(', ') }}
            </h2>
          </div>
        </div>

        <!-- Country -->
        <div
          class="info-rect-piece"
          v-if="record.country.length"
        >
          <div class="rect-piece-title">
            País
          </div>
          <div class="rect-piece-content">
            <h2>
              {{ record.country }}
            </h2>
          </div>
        </div>

        <!-- Year -->
        <div 
          class="info-rect-piece"
          v-if="record.year.length"
        >
          <div class="rect-piece-title">
            Año
          </div>
          <div class="rect-piece-content">
            <h2>
              {{ record.year }}
            </h2>
          </div>
        </div>

        <!-- Genre -->
        <div
          class="info-rect-piece"
          v-if="record.genre.length"
        >
          <div class="rect-piece-title">
            Género
          </div>
          <div class="rect-piece-content">
            <h2>
              {{ record.genre }}
            </h2>
          </div>
        </div>
      </div>

      <!-- Line break -->
      <SquaresRoad class="second-line-break" :squareNum="18" :squareHeight="3" :roadWidth="50"/>

      <!-- Content division -->
      <div class="content-division">

        <div class="left-pannel">
          <img
            :src="`https://storage.googleapis.com/cartografiadigital/records_imgs/${record.code}.png`"
          />
        </div>

        <div class="right-pannel">

          <div class="buttons-row">
            <button
              class="button first"
              :onclick="`window.open('${record.repositoryLink}', '_blank')`"
              type="button"
            >
              Ir al archivo
            </button>
          </div>

          <!-- Collaborators -->
          <div 
            class="record-details"
            v-if="hasColaborators"
          >
            <span class="details-bold">Colaboradores:
              </span><span 
                v-for="(colab, idx) in record.colaborators"
                :key="idx">
                  <!-- Checks if it's the last colaborator on the list -->
                  {{ 
                    idx === record.colaborators.length - 1
                    ? `${colab}` : `${colab},` 
                  }}
                </span>
          </div>

          <!-- Url -->
          <div
            class="record-details"
            v-for="url in urls"
            :key="url"
          >
            <span class="details-bold">
              Url:
            </span> <a :href="url" target="_blank">{{ url }} </a>
          </div>

          <!-- License -->
          <!-- <div class="record-details">
            <span class="details-bold">
              Licencia:</span> {{ record.cc === 'protected'
              ? 'Obra protegida/Copyright' : 'Creative Commons' }}
          </div> -->

          <div class="record-details">
            <span class="details-bold">
              Licencia:</span> {{ record.rawCC }}
          </div>

          <!-- Description -->
          <div class="record-description">
            {{ record.description }}
          </div>

        </div>
        
      </div>

    </div>
  </div>
</template>

<script>
import SquaresRoad from '../components/SquaresRoad.vue'

export default {
  name: 'Record',
  components: {
    SquaresRoad,
  },
  metaInfo() {
    return {
      title: `${this.record.title} - Cartografía Digital`,
      htmlAttrs: {
        lang: 'es'
      },
      meta: [
        { charset: 'utf-8' },
        {
          name: 'description',
          content: 'Cartografía Digital de la Literatura Latinoamericana.'
        },
        {
          property: 'og:title',
          content: `${this.record.title} - Cartografía Digital`,
          vmid: 'og:title'
        },
        {
          proprty: 'og:type',
          content: 'website',
          vmid: 'og:type',
        }
      ]
    }
  },
  computed: {
    // function to check if the record has colaborators
    hasColaborators() {
      // check if the colabs array is empty
      if (this.record.colaborators.length === 0) return false;
      // check if the first element in the array is an empty string
      else if (
        this.record.colaborators[0].length === 0
      ) return false;
      // otherwise, the record has colaborators
      return true
    },
    urls() {
      return this.record.url.split(";;");
    },
    recordId() {
      return this.$route.params.recordName;
    },
    record() {
      return this.$store.getters.getRecord(this.recordId)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .record-general-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 20px;
  }

  .record-header {
    display: flex;
    justify-content: space-between;
    height: 50px;
    margin-bottom: 40px;
    border-bottom: 1px solid var(--black);
    padding-bottom: 10px;
  }

  .header-left-logo {
    height: 100%;
  }

  .header-left-logo img {
    height: 100%;
  }

  .right-info {
    font-family: var(--courier);
    color: #aa4700;
    display: flex;
    align-items: flex-end;
  }

  .record-content {
    padding: 0 40px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .back {
    font-family: var(--courier);
    font-size: 18px;
  }

  .record-content-left-pannel {
    grid-column: 1 / 2;
    padding-left: 40px;
    padding-right: 20px;
    display: flex;
    flex-direction: column;
  }

  .record-title h1 {
    font-size: 60px;
    font-family: 'Vesper Libre', serif;
    font-weight: 900;
  }

  .first-line-break {
    margin-bottom: 40px;
  }

  .record-info-rect {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }

  .info-rect-piece {
    border-right: 1px solid var(--black);
    padding: 0px 14px;
    font-family: var(--vesper);
  }

  .info-rect-piece.first {
    padding-left: 0px;
  }

  .rect-piece-title {
    text-align: left;
    font-size: 18px;
  }

  .rect-piece-content h2 {
    text-align: left;
    font-size: 38px;
  }

  .second-line-break {
    margin-top: 30px;
  }

  .content-division {
    padding-top: 40px;
    width: 100%;
    display: grid;
    grid-template-columns: 6fr 5fr;
  }

  .left-pannel {
    grid-column: 1 / 2;
    display: flex;
    flex-direction: column;
    padding-right: 20px;
  }

  .left-pannel .image {
    width: 100%;
    height: 500px;
    background-color: #262626;
    margin-bottom: 40px;
  }

  .right-pannel {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 20px;
  }

  .buttons-row {
    width: 100%;
    display: flex;
    justify-content: left;
    margin-bottom: 25px;
  }

  .button.first {
    margin-left: 0;
  }

  .button {
    display: inline-block;
    font-family: 'Courier Prime', monospace;
    height: 30px;
    border-radius: 5px;
    color: white;
    background-color: #383838;
    padding: 0 10px;
    margin: 0px 5px;
  }

  .record-details {
    font-family: 'Courier Prime', monospace;
    font-size: 18px;
    margin: 5px 0px;
  }

  .details-bold {
    font-weight: bold;
  }

  .record-description {
    font-size: 18px;
    font-family: 'Vesper Libre', serif;
  }

  .record-description {
    margin-top: 20px;
  }

</style>
